
































































import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'
import {
  AbsencesAssistantStartEndPayload,
  CompanyFilterValue,
} from '@/types/payload'
import {
  GET_SELECTED_UI_LANGUAGE,
  ABSENCES_ASSISTANT_GET_COMPANY_FILTER,
  ABSENCES_ASSISTANT_GET_START_DATE,
  ABSENCES_ASSISTANT_GET_END_DATE, ABSENCES_ASSISTANT_GET_IS_EDITING_SERIE
} from '@/store/getter-types'
import {
  ABSENCES_ASSISTANT_SET_START_END_DATA, LOAD_ABSENCE_REASON_LIST
} from '@/store/action-types'
import { ActionsEnum } from '@/types/enums'
import { AbsenceReason } from '@/model/absences/AbsenceReason'
import { Absence } from '@/model/absences/Absence'
import { AbsenceSerie } from '@/types/service-response'

interface ComponentData {
  dateStartIso: string
  dateEndIso: string
  hourStart: string
  hourEnd: string
  minuteStart: string
  minuteEnd: string
  hourRules: Array<Function>
  minuteRules: Array<Function>
  showErrorBadTime: boolean
  absenceReasonList: Array<AbsenceReason>
  selectedAbsenceReasonId: number | undefined
}

export default Vue.extend({
  name: 'AbsencesEditorStartEnd',

  props: {
    action: {
      type: String as () => ActionsEnum
    },

    editAbsence: Object as () => Absence | undefined,
    editAbsenceSerie: Object as () => AbsenceSerie | undefined,
  },

  computed: {
    dateEndFormatted (): string {
      return moment(this.dateEndIso, 'YYYY-MM-DD').format('DD.MM.YYYY')
    },
    dateStartFormatted (): string {
      return moment(this.dateStartIso, 'YYYY-MM-DD').format('DD.MM.YYYY')
    },
    dateStart (): Date {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_START_DATE]
    },

    dateEnd (): Date {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_END_DATE]
    },

    companyFilter (): CompanyFilterValue {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_COMPANY_FILTER]
    },

    isDataValid (): boolean {
      const conditions = [
        ((): boolean => {
          const start = moment(`${this.dateStartIso} ${this.hourStart}:${this.minuteStart}`)
          const end = moment(`${this.dateEndIso} ${this.hourEnd}:${this.minuteEnd}`)

          return start.isBefore(end)
        })()
      ]

      return conditions.every(v => v)
    },

    isTemplateDisabled (): boolean {
      if(this.editAbsence && this.editAbsence.serieId) {
        return true
      } else {
        return false
      }
    },

    isDateDisabled (): boolean {
      return (this.action === ActionsEnum.EDIT)
    },

    isEdittingSerie (): boolean {
      return this.$store.getters[ABSENCES_ASSISTANT_GET_IS_EDITING_SERIE]
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  data (): ComponentData {

    const todayIso = moment().format('YYYY-MM-DD')

    return {
      dateStartIso: todayIso,
      dateEndIso: todayIso,
      hourStart: '00',
      hourEnd: '00',
      minuteStart: '00',
      minuteEnd: '00',

      hourRules: [
        (v: string) => !!v || this.$t('absencesPage.badValue'),
        (v: string) => {
          const numVal = parseInt(v, 10)
          return (v.indexOf('.') === -1 && numVal >= 0 && numVal < 24) || this.$t('absencesPage.badValue')
        }
      ],

      minuteRules: [
        (v: string) => !!v || this.$t('absencesPage.badValue'),
        (v: string) => {
          const numVal = parseInt(v, 10)
          return (v.indexOf('.') === -1 && numVal >= 0 && numVal < 60) || this.$t('absencesPage.badValue')
        }
      ],

      showErrorBadTime: false,
      absenceReasonList: [],
      selectedAbsenceReasonId: undefined,
    }
  },

  watch: {
    isDataValid (newVal: boolean): void {
      this.showErrorBadTime = !newVal
    },
  },

  methods: {
    onFieldStartChange (): void {
      this.dateEndIso = this.dateStartIso
      this.onFieldValueChange()
    },

    onFieldEndChange (): void {
      this.onFieldValueChange()
    },

    onFieldValueChange (): void {
      if (this.isDataValid) {
        this.showErrorBadTime = false
        this.updateStoreValues()
      } else {
        this.showErrorBadTime = true
      }
    },

    onReasonSelect (): void {
      this.hourStart = this.formatHour(new Date('2021-01-21T00:00:00'))
      this.minuteStart = this.formatMinute(new Date('2021-01-21T00:00:00'))

      this.hourEnd = this.formatHour(new Date('2021-01-21T23:59:59'))
      this.minuteEnd = this.formatMinute(new Date('2021-01-21T23:59:59'))

      this.updateStoreValues()
    },

    formatDateIso (date: Date): string {
      return moment(date).format('YYYY-MM-DD')
    },

    formatHour (date: Date): string {
      return moment(date).format('HH')
    },

    formatMinute (date: Date): string {
      return moment(date).format('mm')
    },

    normalizeDateStart (): Date {
      const dateStart = this.dateStartIso
      const hourStart = this.hourStart
      const minuteStart = this.minuteStart

      const dateStr = `${dateStart} ${hourStart.padStart(2, '0')}:${minuteStart.padStart(2, '0')}`

      return moment(dateStr).toDate()
    },

    normalizeDateEnd (): Date {
      const dateEnd = this.dateEndIso
      const hourEnd = this.hourEnd
      const minuteEnd = this.minuteEnd

      const dateStr = `${dateEnd} ${hourEnd.padEnd(2, '0')}:${minuteEnd.padEnd(2, '0')}`

      return moment(dateStr).toDate()
    },

    updateStoreValues () {
      const reasonItem: AbsenceReason | undefined = _.find(this.absenceReasonList, { id: this.selectedAbsenceReasonId }) as AbsenceReason

      const payload: AbsencesAssistantStartEndPayload = {
        dateStart: this.normalizeDateStart(),
        dateEnd: this.normalizeDateEnd(),
        absenceReasonItem: reasonItem
      }
      this.$store.dispatch(ABSENCES_ASSISTANT_SET_START_END_DATA, payload)
    },
  },

  async mounted () {

    this.dateStartIso = this.formatDateIso(this.dateStart)
    this.hourStart = this.formatHour(this.dateStart)
    this.minuteStart = this.formatMinute(this.dateStart)

    this.dateEndIso = this.formatDateIso(this.dateEnd)
    this.hourEnd = this.formatHour(this.dateEnd)
    this.minuteEnd = this.formatMinute(this.dateEnd)

    if (this.companyFilter.department) {
      this.absenceReasonList = await this.$store.dispatch(LOAD_ABSENCE_REASON_LIST)
      this.selectedAbsenceReasonId = this.absenceReasonList[0].id
      if (this.action !== ActionsEnum.EDIT) {
        this.onReasonSelect()
      }
    }

    if (this.editAbsence) {
      this.selectedAbsenceReasonId = this.editAbsence.reason
      this.updateStoreValues()
    } else if(this.editAbsenceSerie) {
      this.selectedAbsenceReasonId = this.editAbsenceSerie.Grund
      this.updateStoreValues()
    }
  }
})
